<template lang="pug">
.crud
  modal-sales-customer(:id='id')
  .container-fluid
    vm-tabs
      vm-tab(vm-label='General' @click="flag = false")
        vm-row.heading(vm-w="12")
          vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=12)
            div
              h1 General
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
            div(style="display:none;")
              vm-button(icon="plus") {{ $t('strings.add') }}
              vm-tooltip(:text="$t('strings.options')" delay=".5s")
                vm-dropdown(vm-custom-content vm-trigger-click)
                  vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                  vm-dropdown-menu
                    vm-dropdown-item.d-flex.justify-content-between()
                      vm-icon(icon="printer-outline")
                      slot &nbsp;{{ $t('strings.print') }}
                    vm-dropdown-item.d-flex.justify-content-between()
                      vm-icon(icon="trash-2-outline")
                      slot &nbsp;{{ $t('strings.delete') }}
                    vm-dropdown-item.d-flex.justify-content-between()
                      vm-icon(icon="upload-outline")
                      slot &nbsp;{{ $t('strings.import') }}
                    //- More options
                        Agrega mas acciones para colecciones de datos
        vm-row(vm-lg="12")
          vm-col.gutters(vm-lg=3 vm-sm=6 vm-xs=12)
            .card.score-card
              .details
                h4 Cotizaciones al mes
                h5 {{ dashboard.quotations_month_amount | currency }}
              apexchart.floatR(height="80" type="line" :options="options" :series="quotations_month")
          vm-col.gutters(vm-lg=3 vm-sm=6 vm-xs=12)
            .card.score-card
              .details
                h4 Ordenes de Compra al mes
                h5 {{ dashboard.orders_month_amount | currency }}
              apexchart.floatR(height="80" type="line" :options="options" :series="orders_month")
          vm-col.gutters(vm-lg=3 vm-sm=6 vm-xs=12)
            .card.score-card.lastChild
              .details
                h4 Total de ventas al mes
                h5 {{ dashboard.sales_month_count }}
              apexchart.floatR(height="80" type="line" :options="options" :series="sales_month")
          vm-col.gutters(vm-lg=3 vm-sm=6 vm-xs=12)
            .card.score-card
              .details
                h4 Ventas al mes
                h5 {{ dashboard.sales_month_amount | currency }}
              apexchart.floatR(height="80" type="line" :options="options" :series="sales_month")
          vm-col.gutters(vm-lg=3 vm-sm=6 vm-xs=12)
            .card.score-card
              .details
                h4 Cotizaciones al año
                h5 {{ dashboard.quotations_year_amount | currency }}
              apexchart.floatR(height="80" type="line" :options="options" :series="quotations_year")
          vm-col.gutters(vm-lg=3 vm-sm=6 vm-xs=12)
            .card.score-card
              .details
                h4 Ordenes de Compra al año
                h5 {{ dashboard.orders_year_amount | currency }}
              apexchart.floatR(height="80" type="line" :options="options" :series="orders_year")
          vm-col.gutters(vm-lg=3 vm-sm=6 vm-xs=12)
            .card.score-card.lastChild
              .details
                h4 Total de ventas al año
                h5 {{ dashboard.sales_year_count }}
              apexchart.floatR(height="80" type="line" :options="options" :series="sales_year")
          vm-col.gutters(vm-lg=3 vm-sm=6 vm-xs=12)
            .card.score-card.lastChild
              .details
                h4 Ventas al año
                h5 {{ dashboard.sales_year_amount | currency }}
              apexchart.floatR(height="80" type="line" :options="options" :series="sales_year")
          vm-col.gutters(vm-lg=3 vm-sm=6 vm-xs=12)
            .card.score-card.lastChild
              .details
                h4 Total de facturaciones pagadas al año
                h5 {{ dashboard.payed_invoices_year_amount | currency }}
              apexchart.floatR(height="80" type="line" :options="options" :series="payed_invoices_year")
          vm-col.gutters(vm-lg=3 vm-sm=6 vm-xs=12)
            .card.score-card.lastChild
              .details
                h4 Total Facturaciones pagadas al mes
                h5 {{ dashboard.payed_invoices_month_amount | currency }}
              apexchart.floatR(height="80" type="line" :options="options" :series="payed_invoices_month")
          vm-col.gutters(vm-lg=3 vm-sm=6 vm-xs=12)
            .card.score-card.lastChild
              .details
                h4 Total de facturaciones al año
                h5 {{ dashboard.invoices_year_amount | currency }}
              apexchart.floatR(height="80" type="line" :options="options" :series="invoices_year")
          vm-col.gutters(vm-lg=3 vm-sm=6 vm-xs=12)
            .card.score-card.lastChild
              .details
                h4 Total Facturaciones al mes
                h5 {{ dashboard.invoices_month_amount | currency }}
              apexchart.floatR(height="80" type="line" :options="options" :series="invoices_month")

        vm-row(vm-w=12)
          vm-col(vm-lg=12)
            .card
              apexchart(height="350" width="98%" type="area" :options="chartOptions" :series="sales_quotations")
        vm-row(vm-w="12")
          vm-col(vm-lg=12)
            vm-row.heading(vm-w="12")
              vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
                div
                  h2 {{ $t('strings.customers') }}:
                  span {{ $t('strings.description', {attribute: $t('strings.customers')}) }}
                div(style="display:none;")
                  vm-button(type="default" icon="list")
                  vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
        vm-row(vm-w="12")
          vm-col.card(vm-sm=12)
            vm-table(v-model="selected"  max-height="350px" :data="customers" class="customer-table")
              template(slot="thead")
                vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('customers.' + column) }}
              template.center(slot-scope="{data}")
                vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                  vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                    .row(@click="showSales(data[indextr])")
                      slot(v-if="column == 'customer'")  {{data[indextr]['nombre']}}
                      slot(v-if="column == 'totalCM'")  {{data[indextr]['CountM']}}
                      slot(v-if="column == 'totalAM'")  {{data[indextr]['total_salesM'] === null ? 0 : data[indextr]['total_salesM'] | currency}}
                      slot(v-if="column == 'totalCY'")  {{data[indextr]['CountY']}}
                      slot(v-if="column == 'totalAY'")  {{data[indextr]['total_salesY'] === null ? 0 : data[indextr]['total_salesY'] | currency}}
            vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
              transition(name="enter")
                .total-records(v-if="total>0") Total: {{ total | currency }}
      vm-tab(vm-label='Comercial KPIS' @click="flag = true")
        vm-row(vm-w="12" vm-type="flex" vm-justify="space-between" class="information__wrapper")
          vm-col(vm-sm=12)
            vm-row.heading(vm-w="12")
              vm-col(vm-type="flex" vm-align="center" vm-lg=12 vm-sm=12)
                div
                  h1 Comercial KPIS
                    img.icon(src='@/assets/icons/medal.svg')
                div(style="display:none;")
                  vm-button(type="default" icon="list")
                  vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
            vm-row(vm-w="12" style="margin-bottom:1rem;")
              vm-col(vm-type="flex" vm-justify="center" vm-lg=3 vm-sm=3)
                vm-select.filter(:placeholder="$t('dashboard.seller_id')" :label="$t('dashboard.seller_id')" v-model="filtersKpis.seller_id")
                  vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in dashboardCatalog.users")
              vm-col(vm-type="flex" vm-justify="center" vm-lg=3 vm-sm=3)
                vm-select.filter(multiple :placeholder="$t('dashboard.month')" :label="$t('dashboard.month')" v-model="filtersKpis.months")
                  vm-select-item(:key="index" :value="item.value" :text="item.name" v-for="(item,index) in months")
              vm-col(vm-type="flex" vm-justify="center" vm-lg=3 vm-sm=3)
                  vm-date-picker.filter(size="large" :label="$t('dashboard.year')" type="year" :placeholder="$t('strings.select_year')" @on-change="handleKpisYear" :value="kpisYear")
              vm-col(vm-type="flex" vm-lg=3 vm-sm=3 vm-justify="flex-end")
                vm-button(size='large' style="margin-top:1.5rem;" @click="loadKpis(filtersKpis)") {{ $t('strings.apply') }}
            vm-row(style="min-height:250px;" vm-type="flex" vm-justify="space-between" vm-w="12")
              vm-col.padding(vm-sm=12 vm-md=6 vm-lg=2)
                .card
                  .card-body
                    vm-avatar.avatar-radius(size="large" :key="seller_kpis.id" :text="seller_kpis.name" color="primary")
                    h3 {{ seller_kpis.name }}
                    label {{ seller_kpis.email }}
              vm-col.padding(vm-sm=12 vm-md=6 vm-lg=2)
                .card
                  .card-body
                    .card-title {{ $t('strings.quotations') }}
                    .subtitle emitidas por vendedor
                    .indicator {{ kpis.quotations.length }}
              vm-col.padding(vm-sm=12 vm-md=6 vm-lg=2)
                .card
                  .card-body
                    .card-title {{ $t('strings.sales') }}
                    .subtitle realizadas en el mes
                    .indicator {{ kpis.sales_month.length }}
              vm-col.padding(vm-sm=12 vm-md=6 vm-lg=2)
                .card
                  .card-body
                    .card-title {{ $t('strings.sales') }}
                    .subtitle en Dinero
                    .indicator {{ kpis.sales_amount | currency }}
              vm-col.padding(vm-sm=12 vm-md=6 vm-lg=2)
                .card
                  .card-body
                    .card-title {{ $t('strings.commission') }}
                    .subtitle del total de ventas
                    .indicator {{ kpis.commissions_amount | currency }}
        vm-row(vm-w=12 style="margin-top: 20px;")
          vm-col(vm-lg=12)
            .card
              h2 {{ $t('dashboard.annual_sales') }}
              apexchart(height="350" width="100%" type="area" :options="chartOptions" :series="sales_quotations_kpis")
      vm-tab(vm-label='Prospección' @click="flag = false")
        vm-row(vm-w="12" vm-type="flex" vm-justify="space-around" class="information__wrapper")
          vm-col(vm-sm=12)
            vm-row.heading(vm-w="12")
              vm-col(vm-type="flex" vm-align="center" vm-lg=12 vm-sm=12)
                div
                  h1 Prospección
                    img.icon(src='@/assets/icons/target.svg')
                div(style="display:none;")
                  vm-button(type="default" icon="list")
                  vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
            vm-row(vm-w="12" style="margin-bottom:1rem;")
              vm-col(vm-type="flex" vm-justify="center" vm-lg=3 vm-sm=3)
                vm-select.filter(:placeholder="$t('dashboard.seller_id')" :label="$t('dashboard.seller_id')" v-model="filtersProspection.seller_id")
                  vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in dashboardCatalog.users")
              vm-col(vm-type="flex" vm-justify="center" vm-lg=3 vm-sm=3)
                vm-select.filter(:placeholder="$t('dashboard.month')" :label="$t('dashboard.month')" v-model="filtersProspection.months")
                  vm-select-item(:key="index" :value="item.value" :text="item.name" v-for="(item,index) in months")
              vm-col(vm-type="flex" vm-justify="center" vm-lg=3 vm-sm=3)
                  vm-date-picker.filter(size="large" :label="$t('dashboard.year')" type="year" :placeholder="$t('strings.select_year')" @on-change="handleProspectionYear" :value="prospectionYear")
              vm-col(vm-type="flex" vm-lg=3 vm-sm=3 vm-justify="flex-end")
                vm-button(size='large' style="margin-top:1.5rem;" @click="loadProspects(filtersProspection)") {{ $t('strings.apply') }}
            vm-row(style="min-height:250px;" vm-type="flex" vm-justify="space-between" vm-w="12")
              vm-col(vm-sm=12 vm-md=6 vm-lg=2)
                .card
                  .card-body
                    vm-avatar.avatar-radius(size="large" :key="seller_prospection.id" :text="seller_prospection.name" color="primary")
                    h3 {{ seller_prospection.name }}
                    label {{ seller_prospection.email }}
              vm-col(vm-sm=12 vm-md=6 vm-lg=3)
                .card
                  .card-body
                    .card-title Nuevos prospectos
                    .indicator {{ prospection.all_created.length }}
                    .subtitle-indicator
                      lavel(style='color:rgb(23, 201, 100);' v-if="prospection.all_created.length - prospection.last_month.length > 0") + {{ prospection.all_created.length - prospection.last_month.length }}
                      lavel(style='color:rgb(242, 19, 93);' v-if="prospection.all_created.length - prospection.last_month.length < 0") {{ prospection.all_created.length - prospection.last_month.length }}
                      vm-icon(color="success" icon="trending-up-outline" v-if="prospection.all_created.length - prospection.last_month.length > 0")
                      vm-icon(color="danger" icon="trending-down-outline" v-if="prospection.all_created.length - prospection.last_month.length < 0")
                      label contra el mes pasado
              vm-col(vm-sm=12 vm-md=6 vm-lg=3)
                .card
                  .card-body
                    .card-title Leads
                    .subtitle posibles compradores
                    vm-row(vm-justify="space-between" vm-align="center")
                      vm-col.padding(vm-sm=6 vm-md=6 vm-lg=6 vm-align="center")
                        apexchart(height="120" type="radialBar" :options="radialChartOptions" :series="leads_percent")
                      vm-col.padding(vm-sm=6 vm-md=6 vm-lg=6 vm-align="center" )
                        .indicator-percent {{ prospection.all_created.length - prospection.prospects.length }}/{{ prospection.all_created.length }}
              vm-col(vm-sm=12 vm-md=6 vm-lg=3)
                .card
                  .card-body
                    .card-title Prospectos
                    .subtitle que realizaron compra
                    vm-row(vm-justify="space-between" vm-align="center")
                      vm-col(vm-sm=6 vm-md=6 vm-lg=6 vm-align="center")
                        vm-icon(size="large" icon='alert-circle-outline' color="warning" v-if='(prospection.all_created.length - prospection.prospects.length - prospection.leads.length) != prospection.all_created.length')
                        vm-icon(size="large" icon='checkmark-circle-2-outline' color="primary" v-else)
                      vm-col(vm-sm=6 vm-md=6 vm-lg=6 vm-align="center" )
                        .indicator-percent {{ prospection.all_created.length - prospection.prospects.length - prospection.leads.length }}/{{ prospection.all_created.length }}
        vm-row(vm-w="12" style="margin-top: 20px;")
          vm-col.card(vm-sm=12)
            vm-table(v-model="selected"  max-height="350px" :data="prospection.all_created")
              template(slot="thead")
                vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns_prospects") {{ $t('customers.' + column) }}
              template(slot-scope="{data}")
                vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                  vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns_prospects")
                    slot(v-if="column == 'prospect'")  {{ data[indextr]['tradename'] }}
                    vm-icon(size="large" icon='checkmark-circle-2-outline' color="success" v-if="column == 'lead' && data[indextr]['type_prospect'] > 1")
                    vm-icon(size="large" icon='close-circle-outline' color="danger" v-if="column == 'lead' && data[indextr]['type_prospect'] < 2")
                    vm-icon(size="large" icon='checkmark-circle-2-outline' color="success" v-if="column == 'has_sale' && data[indextr]['type_prospect'] > 2")
                    vm-icon(size="large" icon='close-circle-outline' color="danger" v-if="column == 'has_sale' && data[indextr]['type_prospect'] < 3")
                    slot(v-if="column == 'created_at'")  {{ data[indextr]['created_at'] | moment('DD-MMMM-YYYY') }}
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import ModalSalesCustomer from '@/components/modals/ModalSalesCustomer.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Dashboard')

export default {
  name: 'Dashboard',
  components: {
    ModalSalesCustomer
  },
  data: () => ({
    currentPage: 1,
    id: '',
    commissionsMonth: '',
    salesMonth: '',
    customersSeller: '',
    productsSeller: '',
    sellersName: [],
    kpisYear: moment().format('YYYY'),
    prospectionYear: moment().format('YYYY'),
    columns: ['customer', 'totalCM', 'totalAM', 'totalCY', 'totalAY'],
    columns_prospects: ['prospect', 'lead', 'has_sale', 'created_at'],
    filtersKpis: {
      seller_id: 1,
      months: [1],
      kpisYear: moment().format('YYYY')
    },
    filtersProspection: {
      seller_id: 1,
      months: 1,
      prospectionYear: moment().format('YYYY')
    },
    months: [
      {
        name: 'Enero',
        value: 1
      },
      {
        name: 'Febrero',
        value: 2
      },
      {
        name: 'Marzo',
        value: 3
      },
      {
        name: 'Abril',
        value: 4
      },
      {
        name: 'Mayo',
        value: 5
      },
      {
        name: 'Junio',
        value: 6
      },
      {
        name: 'Julio',
        value: 7
      },
      {
        name: 'Agosto',
        value: 8
      },
      {
        name: 'Septiembre',
        value: 9
      },
      {
        name: 'Octubre',
        value: 10
      },
      {
        name: 'Noviembre',
        value: 11
      },
      {
        name: 'Diciembre',
        value: 12
      }
    ],
    options: {
      chart: {
        id: 'vuechart-example',
        sparkline: {
          enabled: true
        },
        dropShadow: {
          color: '#0d4351',
          enabled: false,
          top: 1,
          left: 1,
          blur: 5,
          opacity: 0.1
        }
      },
      stroke: {
        curve: 'smooth',
        width: 2.5
      },
      markers: {
        size: 0
      },
      grid: {
        padding: {
          top: 20,
          bottom: 10,
          left: 110
        }
      },
      colors: ['#98c0cc'],
      fill: {
        type: 'solid',
        gradient: {
          shade: 'dark',
          gradientToColors: ['#026481'],
          shadeIntensity: 1,
          type: 'horizontal',
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100, 100, 100]
        }
      },
      tooltip: {
        theme: 'dark',
        x: {
          show: false
        },
        y: {
          formatter: val => {
            return Vue.filter('currency')(val)
          },
          title: {
            formatter: val => {
              return ''
            }
          }
        }
      }
    },
    chartOptions: {
      stroke: {
        curve: 'smooth'
      },
      chart: {
        id: 'vuechart-example1',
        type: 'area',
        dropShadow: {
          color: '#0d4351',
          enabled: false,
          top: 1,
          left: 1,
          blur: 1,
          opacity: 0.1
        }
      },
      dataLabels: {
        enabled: false
      },
      markers: {
        size: 0,
        style: 'hollow'
      },
      series: [
        {
          data: [400, 430, 448, 470, 540, 580, 690, 1100, 150, 1380]
        }
      ],
      xaxis: {
        categories: [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Septiembre',
          'Octubre',
          'Noviembre',
          'Diciembre'
        ]
      },
      tooltip: {
        x: {
          format: 'dd MMM yyyy'
        },
        y: {
          formatter: val => {
            return Vue.filter('currency')(val)
          }
        }
      },
      colors: ['#026481', '#a46aef'],
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100]
        }
      }
    },
    radialChartOptions: {
      plotOptions: {
        radialBar: {
          dataLabels: {
            showOn: 'always',
            value: {
              offsetY: -10,
              color: '#a46aef',
              fontSize: '12px',
              show: true
            }
          }
        }
      },
      colors: ['#a46aef'],
      stroke: {
        lineCap: 'round'
      },
      labels: ['']
    }
  }),
  computed: {
    ...mapGetters([
      'dashboard',
      'customers',
      'sellers',
      'dashboardCatalog',
      'pagination',
      'kpis',
      'prospection'
    ]),
    quotations_month () {
      let quotations = [
        {
          data: this.getDataDay(
            this.dashboard.quotations_month,
            'total_quotations'
          )
        }
      ]
      return quotations
    },
    sales_month () {
      let sales = [
        {
          data: this.getDataDay(this.dashboard.sales_month_per_day, 'total_sales')
        }
      ]
      return sales
    },
    orders_month () {
      let sales = [
        {
          data: this.getDataDay(this.dashboard.orders_month, 'total_orders')
        }
      ]
      return sales
    },
    sales_year () {
      let sales = [
        {
          data: this.getDataMoth(this.dashboard.sales_year_per_month, 'sum_total')
        }
      ]
      return sales
    },
    orders_year () {
      let orders = [
        {
          data: this.getDataMoth(this.dashboard.orders_year, 'total_orders')
        }
      ]
      return orders
    },
    quotations_year () {
      let orders = [
        {
          data: this.getDataMoth(
            this.dashboard.quotations_year,
            'total_quotations'
          )
        }
      ]
      return orders
    },
    sales_quotations () {
      let orders = [
        {
          name: 'Cotizaciones',
          data: this.getDataMoth(
            this.dashboard.quotations_year,
            'total_quotations'
          )
        },
        {
          name: 'Ventas',
          data: this.getDataMoth(this.dashboard.sales_year_per_month, 'sum_total')
        }
      ]
      return orders
    },
    sales_quotations_kpis () {
      let orders = [
        {
          name: 'Cotizaciones',
          data: this.getDataMoth(this.kpis.quotations_year, 'total_quotations')
        },
        {
          name: 'Ventas',
          data: this.getDataMoth(this.kpis.sales_year, 'sum_total')
        }
      ]
      return orders
    },
    seller_kpis () {
      return this.dashboardCatalog.users.find(
        e => e.id === this.filtersKpis.seller_id
      )
    },
    seller_prospection () {
      return this.dashboardCatalog.users.find(
        e => e.id === this.filtersProspection.seller_id
      )
    },
    sales_quotations_percent () {
      return [
        parseFloat(
          (this.kpis.sales.length * 100) / this.kpis.quotations.length
        ).toFixed(2)
      ]
    },
    leads_percent () {
      return [
        parseFloat(
          ((this.prospection.all_created.length -
            this.prospection.prospects.length) *
            100) /
            this.prospection.all_created.length
        ).toFixed(2)
      ]
    },
    invoices_year () {
      return [
        {
          data: this.dashboard && this.dashboard.invoices_year ? Object.values(this.dashboard.invoices_year) : [],
          name: 'Facturaciones Anual'
        }
      ]
    },
    invoices_month () {
      return [
        {
          data: this.dashboard && this.dashboard.invoices_month ? Object.values(this.dashboard.invoices_month) : [],
          name: 'Facturaciones Mensual'
        }
      ]
    },
    payed_invoices_year () {
      return [
        {
          data: this.dashboard && this.dashboard.payed_invoices_year ? Object.values(this.dashboard.payed_invoices_year) : [],
          name: 'Facturaciones Anual'
        }
      ]
    },
    payed_invoices_month () {
      return [
        {
          data: this.dashboard && this.dashboard.payed_invoices_month ? Object.values(this.dashboard.payed_invoices_month) : [],
          name: 'Facturaciones Mensual'
        }
      ]
    }
  },
  watch: {
    currentPage (currentPage) {
      this.loadCustomers({ page: currentPage })
    }
  },
  async created () {
    this.commissionsMonth = moment()
      .subtract(1, 'months')
      .endOf('month')
      .format('YYYY-MM')
    this.salesMonth = moment()
      .subtract(1, 'months')
      .endOf('month')
      .format('YYYY-MM')
    this.getKpis()
    this.getProspection()
    this.getCatalog()
    await this.loadDashboard()
    await this.loadCustomers({ page: this.currentPage })
  },
  methods: {
    ...mapActions([
      'loadDashboard',
      'loadCustomers',
      'loadSalesCustomers',
      'setModalSalesCustomerVisible',
      'loadCatalog',
      'loadKpis',
      'loadProspects'
    ]),
    getDataMoth (data, column) {
      let months = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      if (!data) return [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      return data.map(value => {
        months[value.month - 1] = parseInt(value[column])
        return months
      })[0]
    },
    getDataDay (data, column) {
      let days = [0]
      if (!data) return [0]
      return data.map(value => {
        days.push(parseInt(value[column]))
        return days
      })[0]
    },
    showSales (record, index) {
      this.id = record.id
      this.setModalSalesCustomerVisible(true)
    },
    async getCatalog () {
      Object.keys(this.dashboardCatalog).forEach(e =>
        this.loadCatalog({ url: e, filter: '' })
      )
    },
    async handleKpisYear (date) {
      this.filtersKpis.kpisYear = date
    },
    async handleProspectionYear (date) {
      this.filtersProspection.prospectionYear = date
    },
    getKpis () {
      this.loadKpis(this.filtersKpis)
    },
    getProspection () {
      this.loadProspects(this.filtersProspection)
    }
  }
}
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 768px) {
  .lastChild {
    margin-bottom: 10px !important;
  }
}

.dashboard {
  background-color: #fafafa;
  padding-top: 100px;
}
.score-card {
  margin: 5px;
}
.floatR {
  z-index: 1000;
  bottom: 0;
}
.details {
  height: 90px !important;
}
.vm-table-text {
  padding-left: 0 !important;
  justify-content: center !important;
}
.customer-table {
  text-align: center !important;
}
.con-vm-chip {
  padding-left: 0 !important;
  width: 100%;
  span {
    padding-left: 0 !important;
    text-align: center !important;
  }
}
h5 {
  font-weight: 100;
  font-size: 21px;
}
.gutters {
  padding: 10px;
}
.center {
  .tr-table {
    td {
      text-align: center !important;
    }
  }
}
.filter {
  padding: 5px 10px;
  width: 100%;
}
.information__wrapper {
  margin-top: 25px;
  .card {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px !important;
    height: 100% !important;
    border-radius: 30px !important;
    .card-body {
      padding: 10px !important;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
}
.avatar-radius {
  border-radius: 80% !important;
  width: 5rem;
  height: 5rem;
  font-size: 2rem;
}
.card-title {
  font-size: 1rem;
  font-weight: bold;
}
.subtitle {
  font-size: 0.8rem;
  color: grey;
}
.subtitle-indicator {
  font-size: 0.8rem;
}
.indicator {
  font-size: 2rem;
  font-weight: bold;
}
.indicator-percent {
  font-size: 2.1rem;
  font-weight: bold;
}
.padding {
  padding: 5px;
}
.icon {
  width: 35px;
  height: auto;
}
</style>
